export enum ApprovedEventsSheetSyncEventOutcome {
    Created = 0,
    Updated = 1,
    Moved = 2,
    Skipped = 3,
    Failed = 4,
}

export interface ApprovedEventsSheetSyncEventResultDto {
    eventId: string
    eventName: string
    startsAt: string
    outcome: ApprovedEventsSheetSyncEventOutcome
    errorMessage: string | null
}

export interface ForceApprovedEventsSheetSyncResultDto {
    alreadyRunning: boolean
    spreadsheetNotConfigured: boolean
    createdCount: number
    updatedCount: number
    movedCount: number
    skippedCount: number
    failedCount: number
    eventResults: ApprovedEventsSheetSyncEventResultDto[]
}
